"use client";

import { useLocalization } from "@faire/localization/react/useLocalization";
import { Logger } from "@faire/observability-core/logging";
import { useCallback } from "react";

// Lazy: see comment in `core/localeKeyToLocaleString.ts`.
const getLogger = () => Logger.getLogger("LOCALIZATION").logger;

interface LocalNumFunction {
  (value: number, opts?: Intl.NumberFormatOptions): string;
  (
    value: number | undefined,
    opts?: Intl.NumberFormatOptions
  ): string | undefined;
  (value?: number, opts?: Intl.NumberFormatOptions): string | undefined;
}

export const useLocalNum = (): { localNum: LocalNumFunction } => {
  const { currencyFormatLocale } = useLocalization();
  const localNumHook = useCallback(
    (value: number, opts?: Intl.NumberFormatOptions): string | undefined => {
      if (value === undefined) {
        return undefined;
      }

      try {
        return Intl.NumberFormat(currencyFormatLocale, opts).format(value);
      } catch (error) {
        getLogger().error(
          `Error formatting number in useLocalNum. error: ${error}, currencyFormatLocale: ${currencyFormatLocale}, value: ${value}, opts: ${opts}`
        );
        return undefined;
      }
    },
    [currencyFormatLocale]
  ) as LocalNumFunction;
  return { localNum: localNumHook };
};
